import { render } from "./ForeignUser.vue?vue&type=template&id=ad6b232a"
import script from "./ForeignUser.vue?vue&type=script&lang=js"
export * from "./ForeignUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__